// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-activator[data-v-c0e2d920]{margin-left:.1875rem}.aspect-radio[data-v-c0e2d920] .v-radio:not(.v-item--active) .v-icon.v-icon{color:#bdbdbd!important}.disabled-block .page-subtitle[data-v-c0e2d920]{color:#bdbdbd}.disabled-block[data-v-c0e2d920] .theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon,.disabled-block[data-v-c0e2d920] label{color:#bdbdbd!important}", ""]);
// Exports
module.exports = exports;
